import React, { useState, useEffect } from 'react';
import UsersService, { BOAPI } from '../service/UsersService';
import { useNavigate } from "react-router-dom";

// כל משתמש שנרשם (SignUp) מופעל מיידית (isActive=1) - אין קונספט של "ממתין
// לאישור אדמין", אז המסך כאן פשוט: טבלת כל המשתמשים. תפקיד (user/owner/
// admin) נערך מתוך כרטיס המשתמש (UserDetails.jsx), לא כאן
const UsersTab = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await UsersService.getUsers(async () => {
        const resp = await BOAPI.fetchUsers();
        if (resp?.[0]?.[0]?.code === 0) return resp[1] || [];
        throw new Error(resp?.[0]?.[0]?.msg || 'שגיאה בטעינה');
      });
      setUsers(data);
    } catch {
      setError('שגיאה בטעינת המשתמשים');
    } finally {
      setLoading(false);
    }
  };

  const fmtDate = (d) => d
    ? new Date(d).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '-';

  const filteredUsers = search.trim()
    ? users.filter((u) => {
      const q = search.trim().toLowerCase();
      return [u.fName, u.lName, u.email, u.phone].some((v) => (v || '').toLowerCase().includes(q));
    })
    : users;

  return (
    <div style={s.container}>
      <div style={s.headerRow}>
        <h2 style={s.title}>ניהול משתמשים</h2>
        <span style={s.totalBadge}>{users.length} משתמשים</span>
      </div>

      {error && (
        <div style={s.errorBanner}>❌ {error}
          <button style={s.closeErr} onClick={() => setError('')}>✕</button>
        </div>
      )}

      <input
        type="text"
        placeholder="חיפוש לפי שם, אימייל או טלפון..."
        style={s.searchInput}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <div style={s.center}>טוען משתמשים...</div>
      ) : filteredUsers.length === 0 ? (
        <div style={s.emptyState}>
          <div style={{ fontSize: 48 }}>👤</div>
          <p style={{ color: '#697386', fontWeight: 600 }}>לא נמצאו משתמשים</p>
        </div>
      ) : (
        <div style={s.tableWrapper}>
          <table style={s.table}>
            <thead>
              <tr style={s.headerRow2}>
                <th style={s.th}>ID</th>
                <th style={s.th}>שם</th>
                <th style={s.th}>אימייל</th>
                <th style={s.th}>טלפון</th>
                <th style={s.th}>תפקיד</th>
                <th style={s.th}>סטטוס</th>
                <th style={s.th}>נרשם</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(user => (
                <tr
                  key={user.id}
                  style={s.row}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                >
                  <td style={s.td}><span style={s.idText}>{user.id}</span></td>
                  <td style={s.td}>
                    <button
                      style={s.nameLink}
                      onClick={() => navigate(`/users/${user.id}`)}
                    >
                      {user.fName} {user.lName}
                    </button>
                  </td>
                  <td style={s.td}>{user.email || '-'}</td>
                  <td style={s.td}>{user.phone || '-'}</td>
                  <td style={s.td}>
                    <span style={{
                      ...s.roleBadge,
                      background: user.role === 'admin' ? '#FEF9EE' : '#EEF2FF',
                      color: user.role === 'admin' ? '#C9A84C' : '#1f6feb',
                    }}>
                      {user.role || 'user'}
                    </span>
                  </td>
                  <td style={s.td}>
                    <span style={{ ...s.statusBadge, ...(user.isActive ? s.statusActive : s.statusInactive) }}>
                      {user.isActive ? 'פעיל' : 'לא פעיל'}
                    </span>
                  </td>
                  <td style={s.td}>{fmtDate(user.iTime)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const s = {
  container:    { padding: 20, direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  headerRow:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
  title:        { margin: 0, color: '#1a1f36', fontSize: 24, fontWeight: 'bold' },
  totalBadge:   { background: '#e8eaf6', color: '#1f6feb', borderRadius: 12, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
  center:       { padding: 40, textAlign: 'center', color: '#999' },
  errorBanner:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffebee', color: '#c62828', padding: 14, borderRadius: 6, marginBottom: 16 },
  closeErr:     { background: 'transparent', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: 18 },
  emptyState:   { textAlign: 'center', padding: '60px 0' },
  searchInput:  { width: '100%', maxWidth: 360, padding: '9px 14px', borderRadius: 10, border: '1.5px solid #e3e8ee', fontSize: 13, marginBottom: 18, boxSizing: 'border-box' },

  tableWrapper: { overflowX: 'auto', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  table:        { width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' },
  headerRow2:   { backgroundColor: '#f5f7fa', borderBottom: '2px solid #e3e8ee' },
  th:           { padding: '14px 16px', textAlign: 'right', fontWeight: 700, color: '#4f566b', fontSize: 13, borderBottom: '2px solid #e3e8ee' },
  row:          { borderBottom: '1px solid #f0f2f5', cursor: 'pointer', transition: 'background 0.15s' },
  td:           { padding: '14px 16px', color: '#4f566b', fontSize: 13, textAlign: 'right' },
  idText:       { fontWeight: 700, color: '#a3acb9' },
  nameLink:     { background: 'none', border: 'none', cursor: 'pointer', color: '#1f6feb', fontWeight: 700, fontSize: 13, padding: 0 },
  roleBadge:    { display: 'inline-block', borderRadius: 12, padding: '3px 10px', fontSize: 11, fontWeight: 700 },
  statusBadge:  { display: 'inline-block', borderRadius: 12, padding: '3px 10px', fontSize: 11, fontWeight: 700 },
  statusActive: { background: '#e8f5e9', color: '#2e7d32' },
  statusInactive: { background: '#f4f6f8', color: '#697386' },
};

export default UsersTab;
